export const FEATURE_ENTRY_VISIBILITY = Object.freeze({
    VISIBLE: 'visible'
});

export const FEATURE_CONTENT_VISIBILITY = Object.freeze({
    FULL: 'full',
    RESTRICTED: 'restricted'
});

export const FEATURE_AVAILABILITY = Object.freeze({
    AVAILABLE: 'available',
    LOCKED: 'locked',
    UNAVAILABLE_TIER: 'unavailable_tier',
    INSUFFICIENT_CREDITS: 'insufficient_credits'
});

export const FEATURE_ACTION_MODE = Object.freeze({
    DIRECT: 'direct',
    NEED_CONFIRM: 'need_confirm',
    UPGRADE_ONLY: 'upgrade_only',
    BLOCKED: 'blocked'
});

export const FEATURE_CREDIT_ACTION = Object.freeze({
    NONE: 'none',
    DEFAULT_CHARGE: 'default_charge',
    CONFIRM_CHARGE: 'confirm_charge'
});

export const FEATURE_CREDIT_RULE = Object.freeze({
    NONE: 'none',
    DEFAULT: 'default',
    CONFIRM: 'confirm'
});

const FEATURE_CREDIT_RULE_TO_ACTION = Object.freeze({
    [FEATURE_CREDIT_RULE.NONE]: FEATURE_CREDIT_ACTION.NONE,
    [FEATURE_CREDIT_RULE.DEFAULT]: FEATURE_CREDIT_ACTION.DEFAULT_CHARGE,
    [FEATURE_CREDIT_RULE.CONFIRM]: FEATURE_CREDIT_ACTION.CONFIRM_CHARGE
});

export const FEATURE_REASON_CODE = Object.freeze({
    AVAILABLE_NO_CHARGE: 'available_no_charge',
    AVAILABLE_DEFAULT_CHARGE: 'available_default_charge',
    AVAILABLE_UNLOCKED_IMAGE: 'available_unlocked_image',
    LOCKED_CONFIRM_REQUIRED: 'locked_confirm_required',
    UNAVAILABLE_FOR_TIER: 'unavailable_for_tier',
    INSUFFICIENT_CREDITS_DEFAULT: 'insufficient_credits_default_charge',
    INSUFFICIENT_CREDITS_CONFIRM: 'insufficient_credits_confirm_charge'
});

export function normalizeFeatureKey(featureCode, subFeatureCode) {
    return `${String(featureCode || '').trim()}::${String(subFeatureCode || '').trim()}`;
}

export function getCreditActionByRule(creditRule = FEATURE_CREDIT_RULE.NONE) {
    return FEATURE_CREDIT_RULE_TO_ACTION[creditRule] || FEATURE_CREDIT_ACTION.NONE;
}

export function getFeatureCreditCost(policy, tierId) {
    const rawCost = policy?.creditCostByTier?.[tierId];
    if (!Number.isFinite(rawCost) || rawCost <= 0) {
        return 0;
    }
    return Number(rawCost);
}

export function isFeatureUnlocked(imageUnlockState, featureCode, subFeatureCode) {
    const unlockedFeatures = Array.isArray(imageUnlockState?.unlockedFeatures)
        ? imageUnlockState.unlockedFeatures
        : [];
    const targetKey = normalizeFeatureKey(featureCode, subFeatureCode);

    return unlockedFeatures.some((item) => {
        if (typeof item === 'string') {
            return item === targetKey;
        }
        if (!item || typeof item !== 'object') {
            return false;
        }
        return normalizeFeatureKey(item.featureCode, item.subFeatureCode) === targetKey;
    });
}

export function createFeatureAccessDecision({
    contentVisibility,
    availability,
    actionMode,
    creditAction,
    reasonCode
}) {
    return {
        entryVisibility: FEATURE_ENTRY_VISIBILITY.VISIBLE,
        contentVisibility,
        availability,
        actionMode,
        creditAction,
        ...(reasonCode ? { reasonCode } : {})
    };
}
